import { useEffect } from "react";
import Header from "@/components/Header";
import FooterSection from "@/components/FooterSection";
import useSEO from '@/hooks/useSEO';

// Import refactored components
import HeroSection from "@/components/about/HeroSection";
import WhatSetsUsApart from "@/components/about/WhatSetsUsApart";
import CutThroughHype from "@/components/about/CutThroughHype";
import TrustSection from "@/components/about/TrustSection";
import AdvisorsSection from "@/components/about/AdvisorsSection";
import CtaSection from "@/components/about/CtaSection";

const AboutUs = () => {
  // Enhanced SEO implementation
  useSEO({
    title: "About Us | DocketLabs - Legal AI Consultancy",
    description: "Meet DocketLabs' legal AI experts. We help law firms implement AI solutions safely and effectively. Learn why firms trust our expertise.",
    ogTitle: "About DocketLabs - Legal AI Experts & Consultants",
    ogDescription: "Meet the DocketLabs team of legal AI experts helping law firms implement AI solutions safely and effectively across the United States.",
    ogImage: '/lovable-uploads/Joey_Layne_2025.JPEG',
    ogUrl: 'https://docketlabs.com/about-us',
    canonical: 'https://docketlabs.com/about-us',
    twitterTitle: "About DocketLabs - Legal AI Experts",
    twitterDescription: "Meet our team of legal AI experts helping law firms implement AI solutions safely and effectively.",
  });

  useEffect(() => {
    
    // Handle scroll restoration
    history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    
    // Initialize animations when DOM is fully loaded
    const initAnimations = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('appear');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      
      document.querySelectorAll('.animate-fade-in, .animate-scale-in, .animate-slide-in-right, .animate-slide-in-left').forEach((element) => {
        observer.observe(element);
      });
    };
    
    window.addEventListener('load', initAnimations);
    return () => window.removeEventListener('load', initAnimations);
  }, []);
  
  return (
    <>
      <Header />
      <main className="bg-white text-foreground overflow-hidden">
        <HeroSection />
        <WhatSetsUsApart />
        <CutThroughHype />
        <TrustSection />
        <AdvisorsSection />
        <CtaSection />
      </main>
      <FooterSection />
    </>
  );
};

export default AboutUs;
